/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Section_DashboardInputs */

const cs_nav_section_dashboard = /** @type {(inputs: Nav_Section_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přehled`)
};

const en_nav_section_dashboard = /** @type {(inputs: Nav_Section_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

/**
* | output |
* | --- |
* | "Dashboard" |
*
* @param {Nav_Section_DashboardInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_section_dashboard = /** @type {((inputs?: Nav_Section_DashboardInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Section_DashboardInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_section_dashboard(inputs)
	return cs_nav_section_dashboard(inputs)
});